import { HttpRequest, AvtGateway } from '../../../kernel/avt.gateway'
import { Module, Permission, PermissionType, SubModule } from '../domain/module'
import { ModuleRepository } from '../domain/module.repository'

type AvtModule = {
  active_for_client: boolean
  description: string
  id: string
  name: string
}
type AvtPermission = {
  id: string
  name: string
  type: string
  description: string
  sub_module_id: string
}
type AvtSubModule = {
  description: string
  id: string
  module_id: string
  name: string
  permissions: AvtPermission[]
}
type ResponseGetModules = {
  data: {
    modules: AvtModule[]
  }
}
type ResponseGetModulePermissions = {
  data: {
    sub_modules: AvtSubModule[]
  }
}

export const odinModuleRepository: ModuleRepository = {
  getModules: async (): Promise<Module[]> => {
    const request: HttpRequest = {
      method: 'GET',
      endpoint: '/avt/api/modules'
    }

    const response: ResponseGetModules = await AvtGateway.executeGetRequest<ResponseGetModules>({
      ...request
    })
    const modules: Module[] = response.data.modules.map((module: AvtModule) => {
      return {
        id: module.id,
        name: module.name,
        activeForClient: module.active_for_client,
        description: module.description
      }
    })
    return modules
  },
  getModulePermissions: async (moduleId: string): Promise<SubModule[]> => {
    const request: HttpRequest = {
      method: 'GET',
      endpoint: `/avt/api/modules/${moduleId}/permissions`
    }
    const response: ResponseGetModulePermissions = await AvtGateway.executeGetRequest<ResponseGetModulePermissions>({
      ...request
    })
    const subModule: SubModule[] = response.data.sub_modules.map((avtSubModule: AvtSubModule): SubModule => {
      const subModule: SubModule = {
        id: avtSubModule.id,
        name: avtSubModule.name,
        description: avtSubModule.description,
        moduleId: avtSubModule.module_id,
        permissions: avtSubModule.permissions.map((avtPermission: AvtPermission): Permission => {
          return {
            id: avtPermission.id,
            type: avtPermission.type as keyof typeof PermissionType,
            name: avtPermission.name,
            description: avtPermission.description,
            subModuleId: avtPermission.sub_module_id
          }
        })
      }
      return subModule
    })
    return subModule
  }
}
